import { defineStore } from 'pinia'
import beApiClient from "@/src/be-api-client";
import {APIRoute, EP, APIBaseRoute} from "@/src/endpoints";
import { handleErrors, makeRequest } from "@/src/utils";

export const useMatchStore = defineStore('match', {
  state: ()=> {
    return {
      // lookup data
      
    }
  },
  actions: {
    // Generic load data method
    loadEntity(url, key, params = {}) {
      return new Promise((resolve, reject) => {
        beApiClient.get(url, params).then(response => {
          this[key] = response.data;
          resolve();
        }).catch(error => {
          const message = handleErrors(error);
          reject(message);
        });
      });
    },
    loadMatch(id, external=false, params=null) {
      return makeRequest(beApiClient.get, APIRoute(external? EP.external_clinical.matches.show : EP.matches.show, { id: id }), params);
    },
    updateMatch(id, payload){
      return makeRequest(beApiClient.put, APIRoute(EP.matches.decline, { id: id }), { match: payload });
    },
    updateOffer(id, payload){
      return makeRequest(beApiClient.put, APIRoute(EP.offers.update, { id: id }), { match: payload });
    },
    troubleshootMatches(payload) {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.troubleshoot.matches.search), { params: payload });
    },
    offersTransfer(payload) {
      return makeRequest(beApiClient.post, APIRoute(EP.matches.bulk_ops.offer_transfer), { match: payload });
    },
    offerAssignment(matchId, payload) {
      return makeRequest(beApiClient.patch, APIRoute(EP.matches.assignments.update, { match_id: matchId }), { match: payload });
    }
  }
});